const BlogsData = [
  {
    id: 1,
    name: "10 things I learn about Javascript",
    img: "https://i.ibb.co/Y7PbNKV/image.png",
    description:
      "There are 7 types of data available in javascript. {number, string, boolean, undefined, null, object, symble}. This data have two categories one is primitive and another one is non-primitive. The object is only non-primitive and all other data is primitive. The difference between primitive and non-primitive is that primitive values are immutable and non-primitive values are mutable and Primitives are stored by value while Non-Primitive (objects) are stored by reference.",
  },
  {
    id: 2,
    name: "10 things I learn about Javascript",
    img: "https://i.ibb.co/w47n7nB/image.png",
    description:
      "There are 7 types of data available in javascript. {number, string, boolean, undefined, null, object, symble}. This data have two categories one is primitive and another one is non-primitive. The object is only non-primitive and all other data is primitive. The difference between primitive and non-primitive is that primitive values are immutable and non-primitive values are mutable and Primitives are stored by value while Non-Primitive (objects) are stored by reference.",
  },
  {
    id: 3,
    name: "10 things I learn about Javascript",
    img: "https://i.ibb.co/mbK4Y76/image.png",
    description:
      "There are 7 types of data available in javascript. {number, string, boolean, undefined, null, object, symble}. This data have two categories one is primitive and another one is non-primitive. The object is only non-primitive and all other data is primitive. The difference between primitive and non-primitive is that primitive values are immutable and non-primitive values are mutable and Primitives are stored by value while Non-Primitive (objects) are stored by reference.",
  },
];

export default BlogsData;
